import { gql } from "@apollo/client";

export const UPLOAD_QUESTIONS_BANK = gql`
mutation uploadMultipleQuestionBanks(
  $classroomId: UUID!
  $subjectId: UUID!
  $files: [QuestionBankFileInput!]!
) {
  uploadMultipleQuestionBanks(
    input: { classroomId: $classroomId, subjectId: $subjectId, files: $files }
  ) {
    result
  }
}
`
export const GET_ALL_QUESTIONS_BANK = gql`
query getAllQuestionBanks($input: getQuestionBankInput!) {
  getAllQuestionBanks(input: $input) {
    allquestionbanks {
      fileId
      filepath
      filename
      filesize
      isclassroom
      questions
      status
      totalQuestions
      totalScore
      feedId
      sharedBy
    }
    totalCount
  }
}
`

export const UPDATE_QUESTIONS_BANK_RESULTS = gql`
mutation updateQuestionBankResults($input: updateQuestionBankInput!) {
  updateQuestionBankResults(input: $input) {
    colorCode
    message
    totalQuestions
    totalScore
  }
}
`

export const VIEW_ALL_MATERIAL_ADMIN_QUESTION_BANK = gql `
query getAllQuestionBanks($input: getQuestionBankInput!) {
  getAllQuestionBanks(input: $input) {
    allquestionbanks {
      fileId
      filepath
      filename
      filesize
      isclassroom
      questions
      status
      totalQuestions
      totalScore
      feedId
    }
    totalCount
  }
}
`
export const UPLOAD_QUESTIONS_BANK_ADMIN = gql `
mutation UploadQuestionBanksByAdmin(
  $files: [QuestionBankFileInput!]!
  $classroomIds: [String!]
  $subjectId: String!
) {
  uploadQuestionBanksByAdmin(
    input: { sjId: $subjectId, files: $files, classroomIds: $classroomIds }
  ) {
    result
  }
}
`
